<template>
    <div>401</div>
</template>
<script>
export default {
    name: "page401"
}
</script>
